import { Api } from '../../axios-config';
import jwt_decode from "jwt-decode";
export type TJwtToken = {
  email: string;
  AlterarSenha: boolean;
  Indexar: boolean;
  CNPJPadrao: string;
  exp: number;
  iat: number;
  name: number;
  nbf: number;
  role: string;
}

const auth = async (email: string, password: string): Promise<string | Error> => {
  try {
    const { data } = await Api.post('Usuario/login', { email: email, senha: password }, { headers: { 'Content-Type': 'application/json' } });

    if (data) {
      // pegar o token e verificar se a edição de senha é obrigatória
      var decoded: TJwtToken = jwt_decode(data.token);

      if (decoded.AlterarSenha) localStorage.setItem("AlterarSenha", "true");

      Api.defaults.headers.common["Authorization"] = `Bearer ${data.token}`

      return data.token;
    }
    return new Error('Erro no login.');
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro no login.');
  }
};
const forgotPassword = async (email: string) => {
  try {
    const { data } = await Api.post(`/Usuario/EsquecerSenha?emailRec=${email}`);

    if (data) {
      return data.nome;
    }
    return new Error('Erro ao refazer a senha.');
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro  ao refazer a senha.');
  }
};

export const AuthService = {
  auth,
  forgotPassword,
};